import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet-async";

function RobotsTxtTester() {
  const [url, setUrl] = useState("");
  const [content, setContent] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchRobots = async () => {
    setLoading(true);
    setContent(null);
    setError(null);
    try {
     let baseUrl = url.trim();
      if (!/^https?:\/\//i.test(baseUrl)) {
        baseUrl = "https://" + baseUrl;
      }
     baseUrl = baseUrl.replace(/\/$/, "");

      const candidates = [baseUrl];
      try {
        const alt = new URL(baseUrl);
        if (alt.hostname.startsWith("www.")) {
          alt.hostname = alt.hostname.replace(/^www\./, "");
        } else {
          alt.hostname = "www." + alt.hostname;
        }
        candidates.push(alt.toString());
      } catch (e) {}

      let success = false;
     for (const candidate of candidates) {
  const fetchUrl = candidate.replace(/\/+$/, '') + '/robots.txt';
        try {
          const res = await fetch(fetchUrl);
          if (res.ok) {
            const text = await res.text();
            setContent(text);
            success = true;
            break;
          }
        } catch (err) {
          continue;
        }
      }

      if (!success) {
        throw new Error("robots.txt not found");
      }
    
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const extractRules = (text) => {
    return text
      .split('\n')
      .filter(line => /^(User-agent|Disallow|Allow)/i.test(line))
      .join('\n');
  };

  const extractSitemaps = (text) => {
    return text
      .split('\n')
      .filter(line => /^Sitemap:/i.test(line))
      .join('\n');
  };

  return (
    <>
      <Helmet>
        <title>Robots.txt Tester - Seotic</title>
        <meta name="description" content="Check if your website has a valid robots.txt file" />
      </Helmet>
      <Navbar />
      <div className="min-h-screen px-5 bg-gradient-to-t from-slate-100 to-white">
        <div className="container mx-auto pt-20 pb-5">
	        <div className="flex flex-col justify-center items-center mb-8">
            <h2 className="text-center text-base/7 uppercase text-slate-400">PUBLIC TOOL</h2>
            <p className="mx-auto mt-2 max-w-lg text-center text-4xl font-semibold tracking-tight text-pretty text-gray-950 sm:text-5xl">
              Robots.txt tester and guide for beginners
            </p>
          </div>

          <p className="text-center text-slate-600 mb-8">Enter your website URL to check for a robots.txt file.</p>
          <div className="flex mb-6 max-w-md mx-auto">
            <input
              type="text"
              placeholder="example.com"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              className="flex-grow px-5 py-3 border border-slate-200 mr-2 rounded-lg focus:outline-none"
            />
            <button
              onClick={fetchRobots}
              className="px-5 py-3 bg-yellow-300 text-yellow-900 rounded-lg hover:bg-yellow-400"
            >
             <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="28" height="28" color="currentColor" fill="none">
    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"></circle>
    <path d="M16 12H8M16 12C16 11.2998 14.0057 9.99153 13.5 9.5M16 12C16 12.7002 14.0057 14.0085 13.5 14.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
</svg>
            </button>
          </div>
          {loading && <p className="text-center my-10">Checking...</p>}
          {error && <p className="text-center text-red-500 my-10">{error}</p>}
          {content && (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-5">
              <div className="bg-white border rounded-lg  p-10">
                <h2 className="mb-5 text-2xl font-medium tracking-tight text-gray-950">Robots.txt Rules</h2>
                <pre className="font-medium tracking-tight text-slate-500 leading-[1.5em] overflow-auto ">{extractRules(content)}</pre>
              </div>
              <div className="bg-white border rounded-lg  p-10">
                <h2 className="mb-5 text-2xl font-medium tracking-tight text-gray-950">Sitemaps</h2>
                <pre className="font-medium tracking-tight text-slate-500 leading-[1.5em] overflow-auto">{extractSitemaps(content) || 'No sitemap found'}</pre>
              </div>
              <div className="bg-white border rounded-lg pb-5">
                <h2 className="mb-5 text-2xl font-medium tracking-tight text-gray-950 px-10 pt-10">Raw robots.txt</h2>
                <pre className="font-medium tracking-tight text-slate-500 leading-[1.5em] overflow-auto bg-slate-50 m-5 p-5">{content}</pre>
              </div>
                         </div>
          )}
           <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
	           <div className="bg-white border rounded-lg  p-10">
		   

  <h2 className="mb-5 text-2xl font-medium tracking-tight text-gray-950">What is robots.txt?</h2>
  <p className="font-medium tracking-tight text-slate-500 leading-[1.5em]">
    A robots.txt file is a small text file placed in the root of your website (like https://yourdomain.com/robots.txt). It tells search engines which pages or folders they can or cannot visit (crawl). This helps manage your site’s visibility in search results.
  </p>
	           </div>
	           
	              	           
	           <div className="bg-white border rounded-lg  p-10">
  <h3 className="mb-5 text-2xl font-medium tracking-tight text-gray-950">Why is it important?</h3>
  <ul className="font-medium tracking-tight text-slate-500 leading-[1.5em] space-y-5">
    <li >Controls which content search engines are allowed to crawl.</li>
    <li>Helps save crawl budget for large websites.</li>
    <li>Prevents indexing of duplicate or private content (like admin panels).</li>
    <li>Links to your sitemap for faster and better indexing.</li>
  </ul>
  </div>
  
  
  
	           <div className="bg-white border rounded-lg  p-10">
  <h3 className="mb-5 text-2xl font-medium tracking-tight text-gray-950">How to create robots.txt</h3>
  <ol className="font-medium tracking-tight text-slate-500 leading-[1.5em] space-y-5">
    <li>Create at <a href="https://app.seotic.co/robot" target="_blank">Seotic's Robots Generator</a> or Create a plain text file and name it <code>robots.txt</code>.</li>
    <li>Add your rules (examples below).</li>
    <li>Upload it to the root directory of your domain (same folder as index.html).</li>
    <li>Check if it works by visiting <code>yourdomain.com/robots.txt</code>.</li>
  </ol>
  </div>
	         	         	        
	                     </div>

        </div>
      </div>
      <Footer />
    </>
  );
}

export default RobotsTxtTester;
